import { render, staticRenderFns } from "./MoveOrgDialog.vue?vue&type=template&id=0fcde26a&"
import script from "./MoveOrgDialog.vue?vue&type=script&lang=js&"
export * from "./MoveOrgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports